import { Helmet } from "react-helmet";
import backgroundImg from "../images/Section-1/background.webp";
import sectionOneImg from "../images/Section-1/section-one-img.webp";

export default function SectionOne({ openModal }: any) {
  return (
    <div className="w-full relative overflow-hidden pt-4 font-aldrich ">
      <Helmet>
        <title>DUMOSH - Double Your Patient Walk-ins</title>
        <meta
          name="description"
          content="DUMOSH helps you focus on treating patients, not marketing headaches. Double your patient walk-ins today!"
        />
        <meta
          property="og:title"
          content="DUMOSH - Double Your Patient Walk-ins"
        />
        <meta
          property="og:description"
          content="DUMOSH helps you focus on treating patients, not marketing headaches."
        />
        <meta property="og:image" content={sectionOneImg} />
        <meta property="og:type" content="website" />
        <link rel="preload" as="image" href={backgroundImg} />
        <link rel="preload" as="image" href={sectionOneImg} />
      </Helmet>
      {/* Background Wrapper */}
      <div
        className="max-w-2xl  md:max-w-full lg:mx-[2rem] absolute inset-0 bg-cover bg-no-repeat bg-center z-0 "
        style={{
          backgroundImage: `url(${backgroundImg})`,
          transform: "scaleX(-1)",
        }}
      ></div>
      <b className="absolute top-4 left-4 lg:top-4 lg:left-10 xl:left-12 text-[10px] md:text-base lg:text-xl xl:text-2xl text-left text-white font-bold font-impact ">
        DUMOSH
        <span className="text-[10px] md:text-base lg:text-xl xl:text-2xl text-left  text-[#FF3E3E] ">
          .
        </span>
      </b>

      {/* Content Wrapper */}
      <div className="relative z-10 max-w-2xl lg:max-w-4xl xl:max-w-[90rem] md:mx-auto flex flex-col space-y-8">
        {/* Main Section */}
        <div className="grid grid-cols-4 gap-1">
          {/* Left Section with Hover Effect */}
          <div
            className="col-span-2  flex relative group z-50 bg-cover bg-no-repeat bg-center -ml-8 h-[200px] md:h-full"
            style={{
              backgroundImage: `url(${sectionOneImg})`,
            }}
          >
          </div>

          {/* Right Section */}
          <div className="col-span-2 flex flex-col p-2 md:px-6 z-10">
            <div className="my-[2px] md:my-4 lg:my-6 xl:m y-10">
              <p className="text-base md:text-xl lg:text-4xl xl:text-5xl text-left text-[#fff] transition-colors duration-300">
                Treat Patients
              </p>
              <p className="text-base md:text-xl lg:text-4xl xl:text-5xl text-left text-[#fff] transition-colors duration-300">
                Not
              </p>
              <p className="text-base md:text-xl lg:text-4xl xl:text-5xl text-left text-[#fff] transition-colors duration-300">
                Marketing Headaches
              </p>
            </div>
            <div className="my-[2px] md:my-4 lg:my-6 xl:m y-10">
              <p className="text-[10px] md:text-base lg:text-xl xl:text-2xl text-left text-[#fff] transition-all duration-300">
                The{" "}
                <b className="text-[10px] md:text-base lg:text-xl xl:text-2xl text-left text-white font-bold font-impact ">
                  DUMOSH
                  <span className="text-[10px] md:text-base lg:text-xl xl:text-2xl text-left  text-[#FF3E3E] ">
                    .
                  </span>
                </b>{" "}
                Effect
              </p>
              <p className="text-[10px] md:text-base lg:text-xl xl:text-2xl text-left text-[#fff] transition-all duration-300">
                Double Your Patient Walk-ins.
              </p>
            </div>
            {/* Bottom Section */}
            <div className="flex justify-start my-[2px] md:my-4 lg:my-6 xl:m  y-10">
              <button
                onClick={openModal}
                className="bg-[#E91212] text-white m-0 p-2 text-xs md:text-2xl lg:text-3xl xl:text-4xl transform transition-transform duration-300 hover:scale-105 active:scale-95"
              >
                Know how
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
